(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sk-addon-guard"] && !Shopify.designMode) return;
  try {
    
(function(){
  function ready(fn){document.readyState!=='loading'?fn():document.addEventListener('DOMContentLoaded',fn);}
  ready(function(){
    var el=document.getElementById('skGuard'); if(!el) return;
    var MAIN=parseInt(el.getAttribute('data-main'),10);
    var ADDONS=el.getAttribute('data-addons').split(',').map(function(x){return parseInt(x,10);});
    if(window.__skGuardRan) return; window.__skGuardRan=true;

    fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(cart){
        var mainQty=0, updates={}, changed=false;
        cart.items.forEach(function(i){
          if(i.product_id===MAIN) mainQty+=i.quantity;
        });
        cart.items.forEach(function(i){
          if(ADDONS.indexOf(i.variant_id)===-1) return;
          if(mainQty<1){ updates[i.variant_id]=0; changed=true; }
          else if(i.quantity>1){ updates[i.variant_id]=1; changed=true; }
        });
        if(!changed) return;
        return fetch('/cart/update.js',{
          method:'POST',
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify({updates:updates})
        }).then(function(){ window.location.reload(); });
      })
      .catch(function(){});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zippizoom-home"] && !Shopify.designMode) return;
  try {
    
(function(){
  var BLUE=43453113139248, RED=43453113598000;
  var SHIP=43453117071408, WARR=43453117104176, MOTOR=43487024939056;
  function ready(fn){document.readyState!=='loading'?fn():document.addEventListener('DOMContentLoaded',fn);}
  ready(function(){
    var root=document.querySelector('.zzh'); if(!root) return;
    var skb=document.getElementById('skb'); if(!skb) return;
    var main=root.querySelector('.zzh-main');

    root.querySelectorAll('.zzh-thumbs img').forEach(function(t){
      t.addEventListener('click',function(){ if(main) main.src=t.src; });
    });

    function buildVars(tier){
      var qty=parseInt(tier.getAttribute('data-qty'),10)||1;
      var box=tier.querySelector('.skb-vars');
      if(!box || box.childElementCount===qty) return;
      box.innerHTML='';
      for(var i=0;i<qty;i++){
        var s=document.createElement('select');
        s.className='skb-var';
        s.innerHTML='<option value="'+BLUE+'">Blue</option><option value="'+RED+'">Red</option>';
        box.appendChild(s);
      }
    }
    skb.querySelectorAll('.skb-tier').forEach(buildVars);

    skb.querySelectorAll('.skb-row').forEach(function(row){
      row.addEventListener('click',function(e){
        e.preventDefault();
        skb.querySelectorAll('.skb-tier').forEach(function(t){t.classList.remove('is-active');});
        var tier=row.closest('.skb-tier');
        tier.classList.add('is-active');
        buildVars(tier);
      });
    });

    var clock=document.getElementById('skbClock');
    if(clock){
      var KEY='sk_bundle_deadline', d=null;
      try{ d=window.sessionStorage.getItem(KEY); }catch(err){}
      if(!d){ d=String(Date.now()+12000000); try{window.sessionStorage.setItem(KEY,d);}catch(err){} }
      d=parseInt(d,10);
      setInterval(function(){
        var ms=d-Date.now(); if(ms<0) ms=0;
        var h=Math.floor(ms/3600000), m=Math.floor(ms%3600000/60000), s=Math.floor(ms%60000/1000);
        clock.textContent=(h<10?'0':'')+h+':'+(m<10?'0':'')+m+':'+(s<10?'0':'')+s;
      },1000);
    }

    var sticky=document.getElementById('skbSticky');
    if(sticky){
      window.addEventListener('scroll',function(){
        sticky.classList.toggle('is-on', window.scrollY>600);
      },{passive:true});
    }

    function addToCart(btn){
      var tier=skb.querySelector('.skb-tier.is-active'); if(!tier) return;
      var qty=parseInt(tier.getAttribute('data-qty'),10)||1;
      var counts={};
      tier.querySelectorAll('.skb-var').forEach(function(s){
        counts[s.value]=(counts[s.value]||0)+1;
      });
      var items=[];
      Object.keys(counts).forEach(function(k){ items.push({id:parseInt(k,10),quantity:counts[k]}); });
      tier.querySelectorAll('.skb-ck').forEach(function(c){
        if(!c.checked) return;
        var a=c.getAttribute('data-addon');
        if(a==='motor'){ items.push({id:MOTOR,quantity:qty}); }
        else if(a==='ship'){ items.push({id:SHIP,quantity:1}); }
        else { items.push({id:WARR,quantity:1}); }
      });
      if(!items.length) return;
      var old=btn.textContent; btn.textContent='Adding…'; btn.disabled=true;
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
        .then(function(r){return r.json();})
        .then(function(){ window.location.href='/cart'; })
        .catch(function(){ btn.textContent=old; btn.disabled=false; });
    }
    var a1=document.getElementById('skbAdd'), a2=document.getElementById('skbAdd2');
    if(a1) a1.addEventListener('click',function(){addToCart(a1);});
    if(a2) a2.addEventListener('click',function(){addToCart(a2);});
  });
})();

  } catch(e) { console.error(e); }
})();
})();
